module.exports = __webpack_public_path__ + "img/1.e6a5825f.jpg";